import { Box, Tab, Tabs, TextField } from '@mui/material'
import { ChangeEvent, SyntheticEvent, useContext } from 'react'
import { addressEntityTabs } from '../address.constant'
import {
  AddressContext,
  AddressProviderValue,
} from '../address.provider'
import FactoredDirectToggle from './factored-direct-toggle/factored-direct-toggle.component'
import AddressCustomerList from './address-customer-list/address-customer-list.component'
import AddressCarrierList from './address-carrier-list/address-carrier-list.component'
import AddressCarrierAddButton from './address-carrier-add-button/address-carrier-add-button.component'
import { useBlockBrowserAutofill } from 'hooks/use-block-browser-autofill'

const AddressSelection = () => {
  const {
    entityTabIndex,
    setEntityTabIndex,
    searchText,
    setSearchText,
    setSelectedAssociationId,
    setDetailTabIndex,
  } = useContext(AddressContext) as AddressProviderValue

  const { blockBrowserAutofill, domFieldName, domFieldId, htmlInputProps } =
    useBlockBrowserAutofill('address-search', true)

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setEntityTabIndex(newValue)
    setSelectedAssociationId(null)
    setDetailTabIndex(0)
  }

  const handleSearchChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchText(event.target.value)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        minWidth: 0,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ flexShrink: 0, pt: 1 }}>
        <Tabs
          value={entityTabIndex}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            '& .Mui-selected': {
              fontWeight: 700,
              color: 'primary.main',
            },
            '& .MuiTab-root.Mui-disabled': {
              opacity: 0.45,
            },
          }}
        >
          {addressEntityTabs.map((tab) => (
            <Tab
              key={tab.id}
              label={tab.label}
              disabled={tab.disabled}
              sx={{ textTransform: 'none', fontSize: '0.95rem' }}
            />
          ))}
        </Tabs>
      </Box>

      {entityTabIndex === 0 && (
        <>
          <Box sx={{ flexShrink: 0, px: 0 }}>
            <FactoredDirectToggle />
            <TextField
              type="text"
              placeholder="Search"
              variant="outlined"
              size="small"
              fullWidth
              name={domFieldName}
              id={domFieldId}
              value={searchText}
              onChange={handleSearchChange}
              slotProps={{
                htmlInput: {
                  ...htmlInputProps,
                  autoComplete: blockBrowserAutofill ? 'new-password' : 'off',
                },
              }}
              sx={{ mb: 1 }}
            />
          </Box>

          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: 'auto',
              overscrollBehaviorY: 'contain',
              mx: -2,
              pb: 1,
            }}
          >
            <AddressCustomerList />
          </Box>
        </>
      )}

      {entityTabIndex === 1 && (
        <Box sx={{ px: 2, py: 3 }}>
          <Box sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
            Coming soon.
          </Box>
        </Box>
      )}

      {entityTabIndex === 2 && (
        <>
          <Box sx={{ flexShrink: 0, px: 0 }}>
            <TextField
              type="text"
              placeholder="Search"
              variant="outlined"
              size="small"
              fullWidth
              name={domFieldName}
              id={domFieldId}
              value={searchText}
              onChange={handleSearchChange}
              slotProps={{
                htmlInput: {
                  ...htmlInputProps,
                  autoComplete: blockBrowserAutofill ? 'new-password' : 'off',
                },
              }}
              sx={{ mb: 1 }}
            />
          </Box>

          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              minWidth: 0,
              overflowY: 'auto',
              overflowX: 'hidden',
              overscrollBehaviorY: 'contain',
              mx: -2,
            }}
          >
            <AddressCarrierList />
          </Box>

          <AddressCarrierAddButton />
        </>
      )}
    </Box>
  )
}

export default AddressSelection
